import { render, staticRenderFns } from "./VideoQuickCreatePage.vue?vue&type=template&id=87c8b1b0&scoped=true"
import script from "./VideoQuickCreatePage.vue?vue&type=script&lang=js"
export * from "./VideoQuickCreatePage.vue?vue&type=script&lang=js"
import style0 from "./VideoQuickCreatePage.vue?vue&type=style&index=0&id=87c8b1b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c8b1b0",
  null
  
)

export default component.exports